'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MealFilter = require('./MealFilter.jsx');

var _MealFilter2 = _interopRequireDefault(_MealFilter);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MealList = function (_React$Component) {
  _inherits(MealList, _React$Component);

  function MealList(props) {
    _classCallCheck(this, MealList);

    var _this = _possibleConstructorReturn(this, (MealList.__proto__ || Object.getPrototypeOf(MealList)).call(this));

    _this.state = {
      total: 0,
      limit: 0,
      skip: 0,
      data: []
    };

    _this.handleCreate = _this.handleCreate.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.handleDelete = _this.handleDelete.bind(_this);
    _this.pickMeal = _this.pickMeal.bind(_this);
    _this.loadMeals = _this.loadMeals.bind(_this);
    return _this;
  }

  _createClass(MealList, [{
    key: 'handleCreate',
    value: function handleCreate(meal) {
      var meals = this.state.data.slice();
      meals.unshift(meal);
      this.setState({
        data: meals.sort(sortByDate)
      });
    }
  }, {
    key: 'handleUpdate',
    value: function handleUpdate(meal) {
      var meals = this.state.data.map(function (data) {
        return data.id === meal.id ? meal : data;
      }).sort(sortByDate);
      this.setState({
        data: meals
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(mealid) {
      var meals = this.state.data.filter(function (data) {
        return data.id !== mealid;
      }).sort(sortByDate);
      this.setState({
        data: meals
      });
    }
  }, {
    key: 'pickMeal',
    value: function pickMeal(meal) {
      this.mealForm.pick(meal);
    }
  }, {
    key: 'loadMeals',
    value: function loadMeals(meals) {
      this.setState({ data: meals });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var canEdit = canEditUserMeals(this.props.currentUser, this.props.user);
      var groups = groupByDate(this.state.data);
      var items = Object.keys(groups).sort().reverse().map(function (date) {
        var group = groups[date];
        var mealitems = group.meals.map(function (meal) {
          return _react2.default.createElement(MealItem, {
            key: meal.id,
            meal: meal,
            canEdit: canEdit,
            onClick: _this2.pickMeal,
            onDelete: _this2.handleDelete });
        });
        var isOverLimit = group.calories > _this2.props.user.goal ? 'isOverLimit' : 'isUnderLimit';
        return _react2.default.createElement(
          'div',
          { key: group.date, className: 'group' },
          _react2.default.createElement(
            'span',
            { className: 'groupDate' },
            group.date
          ),
          _react2.default.createElement(
            'span',
            { className: 'calories ' + isOverLimit },
            group.calories,
            ' cal'
          ),
          _react2.default.createElement('br', null),
          mealitems
        );
      });
      if (!items.length) {
        items.push(_react2.default.createElement(
          'div',
          { className: 'quiet', key: 'nomeals' },
          'No meals found'
        ));
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(MealForm, { user: this.props.user,
          currentUser: this.props.currentUser,
          ref: function ref(mealForm) {
            _this2.mealForm = mealForm;
          },
          onCreate: function onCreate(meal) {
            _this2.handleCreate(meal);
          },
          onUpdate: function onUpdate(meal) {
            _this2.handleUpdate(meal);
          }
        }),
        _react2.default.createElement(_MealFilter2.default, { user: this.props.user,
          ref: function ref(mealFilter) {
            _this2.mealFilter = mealFilter;
          },
          onChange: this.loadMeals
        }),
        _react2.default.createElement(
          'div',
          null,
          items
        )
      );
    }
  }]);

  return MealList;
}(_react2.default.Component);

exports.default = MealList;

var MealItem = function (_React$Component2) {
  _inherits(MealItem, _React$Component2);

  function MealItem() {
    _classCallCheck(this, MealItem);

    var _this3 = _possibleConstructorReturn(this, (MealItem.__proto__ || Object.getPrototypeOf(MealItem)).call(this));

    _this3.handleClick = _this3.handleClick.bind(_this3);
    _this3.remove = _this3.remove.bind(_this3);
    return _this3;
  }

  _createClass(MealItem, [{
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.canEdit) {
        this.props.onClick(this.props.meal);
      }
    }
  }, {
    key: 'remove',
    value: function remove(e) {
      var _this4 = this;

      e.stopPropagation();
      var mealid = this.props.meal.id;
      var mealsService = _client2.default.service('meals');
      var params = { query: { token: _client2.default.get('token') } };
      mealsService.remove(mealid, params).then(function (result) {
        _this4.props.onDelete(mealid);
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var meal = this.props.meal;
      // const canEdit = this.props.meal.userid === this.props.currentUser.id ? 'canEdit' : ''
      var canEdit = this.props.canEdit ? 'canEdit' : '';
      var date = parseDate(meal.date);
      var time = parseTime(meal.date);
      return _react2.default.createElement(
        'div',
        { className: 'meal row ' + canEdit, onClick: this.handleClick },
        _react2.default.createElement(
          'div',
          { className: 'name' },
          meal.name
        ),
        _react2.default.createElement(
          'div',
          { className: 'calories' },
          meal.calories,
          ' cal'
        ),
        _react2.default.createElement(
          'div',
          { className: 'date' },
          date
        ),
        _react2.default.createElement(
          'div',
          { className: 'time' },
          time
        ),
        _react2.default.createElement(
          'div',
          { className: 'remove', onClick: this.remove },
          'x'
        )
      );
    }
  }]);

  return MealItem;
}(_react2.default.Component);

var MealForm = function (_React$Component3) {
  _inherits(MealForm, _React$Component3);

  function MealForm(props) {
    _classCallCheck(this, MealForm);

    var _this5 = _possibleConstructorReturn(this, (MealForm.__proto__ || Object.getPrototypeOf(MealForm)).call(this));

    _this5.state = {
      id: '',
      userid: props.user.id,
      name: '',
      calories: '',
      date: new Date().toISOString()
    };
    _this5.updateState = _this5.updateState.bind(_this5);
    _this5.handleSubmit = _this5.handleSubmit.bind(_this5);
    return _this5;
  }

  _createClass(MealForm, [{
    key: 'reset',
    value: function reset() {
      this.setState({
        id: '',
        name: '',
        calories: '',
        date: new Date().toISOString()
      });
    }
  }, {
    key: 'pick',
    value: function pick(meal) {
      this.setState(meal);
    }
  }, {
    key: 'updateState',
    value: function updateState(event) {
      var _setState;

      var name = event.target.name;
      var value = event.target.value;
      console.log(name, value);
      if (name === 'date') {
        value = new Date(value + 'T' + this.state.date.split("T")[1]).toISOString();
      } else if (name === 'time') {
        value = new Date(this.state.date.split("T")[0] + value).toISOString();
      } else if (name === 'calories') {
        value = parseInt(value);
      }
      this.setState((_setState = {}, _defineProperty(_setState, name, value), _defineProperty(_setState, 'error', null), _setState));
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      event.preventDefault();

      var id = this.state.id;

      if (!id) {
        this.create();
      } else {
        this.update();
      }
    }
  }, {
    key: 'create',
    value: function create() {
      var _this6 = this;

      var mealsService = _client2.default.service('meals');
      var params = { query: { token: _client2.default.get('token') } };

      mealsService.create(this.state, params).then(function (result) {
        _this6.props.onCreate(result);
        _this6.reset();
      }).catch(function (error) {
        console.error(error);
        _this6.setState({
          error: error.toString()
        });
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var _this7 = this;

      var mealsService = _client2.default.service('meals');
      var params = { query: { token: _client2.default.get('token') } };

      mealsService.update(this.state.id, this.state, params).then(function (result) {
        _this7.props.onUpdate(result);
        _this7.reset();
      }).catch(function (error) {
        console.error(error);
        _this7.setState({
          error: error.toString()
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var id = this.state.id;
      var action = id ? 'update' : 'create';
      var canEdit = canEditUserMeals(this.props.currentUser, this.props.user);
      if (!canEdit) {
        return _react2.default.createElement('div', null);
      }
      console.log(this.state.date);

      var date = parseDate(this.state.date);
      var time = parseTime(this.state.date);

      return _react2.default.createElement(
        'form',
        { onSubmit: this.handleSubmit, className: action },
        _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.state.id, readOnly: true }),
        _react2.default.createElement('input', { type: 'hidden', name: 'userid', value: this.state.userid, readOnly: true }),
        _react2.default.createElement('input', { type: 'text', name: 'name', placeholder: 'Name', value: this.state.name, required: true, onChange: this.updateState }),
        _react2.default.createElement('input', { type: 'number', name: 'calories', placeholder: 'Calories', value: this.state.calories, required: true, onChange: this.updateState, min: '0', max: '10000' }),
        _react2.default.createElement('input', { type: 'date', name: 'date', placeholder: 'Date', value: date, required: true, onChange: this.updateState }),
        _react2.default.createElement('input', { type: 'time', name: 'time', placeholder: 'Time', value: time, required: true, onChange: this.updateState, step: '60' }),
        _react2.default.createElement('input', { type: 'submit', value: capitalize(action) }),
        _react2.default.createElement(
          'span',
          { className: 'clear', onClick: function onClick() {
              return _this8.reset();
            } },
          'cancel'
        ),
        _react2.default.createElement(
          'div',
          { className: 'error' },
          this.state.error
        )
      );
    }
  }]);

  return MealForm;
}(_react2.default.Component);

function canEditUserMeals(currentUser, user) {
  var isValidRole = currentUser.role === 'admin';
  return user.id == currentUser.id || isValidRole;
}

function groupByDate(a) {
  return a.reduce(function (rv, x) {
    var date = parseDate(x.date);
    var ab = rv[date] = rv[date] || { date: date, calories: 0, meals: [] };
    ab.meals.push(x);
    ab.calories += x.calories;
    return rv;
  }, {});
}

function sortByDate(a, b) {
  return new Date(b.date) - new Date(a.date);
}

function parseDate(d) {
  return new Date(d).toISOString().substr(0, 10);
}

function parseTime(d) {
  return new Date(d).toISOString().substr(11, 5);
}

function capitalize(s) {
  s = s || '';
  return (s[0] || '').toUpperCase() + s.substr(1);
}


//////////////////
// WEBPACK FOOTER
// ./client/components/MealList.jsx
// module id = 219
// module chunks = 0